import React, { lazy, Suspense, useState, useCallback, useLayoutEffect } from 'react';
import {Mode} from "../redux/reducers/Theme";

const Light = lazy(() => import('./LightTheme'));
const Dark = lazy(() => import('./DarkTheme'));

export const isOsDark = () => window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches

const ThemeProvider: React.FC<{ theme: Mode }> = ({ children, theme }) => {
    const [isMounted, setIsMounted] = useState(false);

    const handleLoaded = useCallback(() => {
        setIsMounted(true);
    }, []);

    const activeTheme = theme === 'auto' ? (isOsDark() ? 'dark' : 'light') : theme;

    return (
        <Suspense fallback={<div className="loading-spinner" />}>
            {activeTheme === 'light' && <Light onLoaded={handleLoaded} />}
            {activeTheme === 'dark' && <Dark onLoaded={handleLoaded} />}

            {/* The children only enter the DOM once the active theme signals it's ready */}
            {isMounted && children}
        </Suspense>
    );
};

export default ThemeProvider;
